import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _0409b50e = () => interopDefault(import('../../../pages/2nd-mortgage.vue' /* webpackChunkName: "pages/2nd-mortgage" */))
const _4735f189 = () => interopDefault(import('../../../pages/2nd-mortgage-landing-page.vue' /* webpackChunkName: "pages/2nd-mortgage-landing-page" */))
const _95ca2f14 = () => interopDefault(import('../../../pages/about-us.vue' /* webpackChunkName: "pages/about-us" */))
const _e5fe36ae = () => interopDefault(import('../../../pages/accessibility-policy.vue' /* webpackChunkName: "pages/accessibility-policy" */))
const _1f7af618 = () => interopDefault(import('../../../pages/asset-based-lending.vue' /* webpackChunkName: "pages/asset-based-lending" */))
const _67d1493a = () => interopDefault(import('../../../pages/blog.vue' /* webpackChunkName: "pages/blog" */))
const _0b85c152 = () => interopDefault(import('../../../pages/brokers.vue' /* webpackChunkName: "pages/brokers" */))
const _95df9e66 = () => interopDefault(import('../../../pages/careers.vue' /* webpackChunkName: "pages/careers" */))
const _f3e61dbe = () => interopDefault(import('../../../pages/communication-policy.vue' /* webpackChunkName: "pages/communication-policy" */))
const _4658a6fa = () => interopDefault(import('../../../pages/contact-us.vue' /* webpackChunkName: "pages/contact-us" */))
const _21668256 = () => interopDefault(import('../../../pages/equipment-financing-landing-page-1.vue' /* webpackChunkName: "pages/equipment-financing-landing-page-1" */))
const _30d284e7 = () => interopDefault(import('../../../pages/equipment-loan.vue' /* webpackChunkName: "pages/equipment-loan" */))
const _04028aa4 = () => interopDefault(import('../../../pages/faq.vue' /* webpackChunkName: "pages/faq" */))
const _5ff9c3a3 = () => interopDefault(import('../../../pages/fb-equipment-financing-landing-page.vue' /* webpackChunkName: "pages/fb-equipment-financing-landing-page" */))
const _46ca7717 = () => interopDefault(import('../../../pages/industries/index.vue' /* webpackChunkName: "pages/industries/index" */))
const _720cd80d = () => interopDefault(import('../../../pages/invest.vue' /* webpackChunkName: "pages/invest" */))
const _15393aaa = () => interopDefault(import('../../../pages/invoice-factoring.vue' /* webpackChunkName: "pages/invoice-factoring" */))
const _39fe1a23 = () => interopDefault(import('../../../pages/john.vue' /* webpackChunkName: "pages/john" */))
const _18e364ca = () => interopDefault(import('../../../pages/jun.vue' /* webpackChunkName: "pages/jun" */))
const _0d26feec = () => interopDefault(import('../../../pages/ken.vue' /* webpackChunkName: "pages/ken" */))
const _41c6c4a8 = () => interopDefault(import('../../../pages/lei.vue' /* webpackChunkName: "pages/lei" */))
const _0fa12f17 = () => interopDefault(import('../../../pages/loan-calculator.vue' /* webpackChunkName: "pages/loan-calculator" */))
const _3de84fb3 = () => interopDefault(import('../../../pages/nonprofit-financing.vue' /* webpackChunkName: "pages/nonprofit-financing" */))
const _495e12a0 = () => interopDefault(import('../../../pages/not-found.vue' /* webpackChunkName: "pages/not-found" */))
const _0ba3ac7a = () => interopDefault(import('../../../pages/partners.vue' /* webpackChunkName: "pages/partners" */))
const _0e12df7a = () => interopDefault(import('../../../pages/privacy-notice-for-california-residents.vue' /* webpackChunkName: "pages/privacy-notice-for-california-residents" */))
const _5edfba2f = () => interopDefault(import('../../../pages/privacy-policy.vue' /* webpackChunkName: "pages/privacy-policy" */))
const _2d5376bb = () => interopDefault(import('../../../pages/roi-calculator.vue' /* webpackChunkName: "pages/roi-calculator" */))
const _4d403b00 = () => interopDefault(import('../../../pages/sba-loans.vue' /* webpackChunkName: "pages/sba-loans" */))
const _2bcb8675 = () => interopDefault(import('../../../pages/team.vue' /* webpackChunkName: "pages/team" */))
const _77ce46af = () => interopDefault(import('../../../pages/terms-of-use.vue' /* webpackChunkName: "pages/terms-of-use" */))
const _d071d158 = () => interopDefault(import('../../../pages/thank-you.vue' /* webpackChunkName: "pages/thank-you" */))
const _a546252c = () => interopDefault(import('../../../pages/vendor-financing.vue' /* webpackChunkName: "pages/vendor-financing" */))
const _16fba94e = () => interopDefault(import('../../../pages/why-american-credit.vue' /* webpackChunkName: "pages/why-american-credit" */))
const _72d3d97e = () => interopDefault(import('../../../pages/working-capital-landing-page.vue' /* webpackChunkName: "pages/working-capital-landing-page" */))
const _c75317a2 = () => interopDefault(import('../../../pages/industries/commercial-construction-loans.vue' /* webpackChunkName: "pages/industries/commercial-construction-loans" */))
const _08d7a7ce = () => interopDefault(import('../../../pages/industries/commercial-real-estate-loans.vue' /* webpackChunkName: "pages/industries/commercial-real-estate-loans" */))
const _40f8f2b1 = () => interopDefault(import('../../../pages/industries/commercial-truck-financing.vue' /* webpackChunkName: "pages/industries/commercial-truck-financing" */))
const _1780f8ac = () => interopDefault(import('../../../pages/industries/commercial-vehicle-loans.vue' /* webpackChunkName: "pages/industries/commercial-vehicle-loans" */))
const _126035ea = () => interopDefault(import('../../../pages/industries/excavator-financing.vue' /* webpackChunkName: "pages/industries/excavator-financing" */))
const _537182d6 = () => interopDefault(import('../../../pages/industries/loans-for-contractors.vue' /* webpackChunkName: "pages/industries/loans-for-contractors" */))
const _304e9de7 = () => interopDefault(import('../../../pages/industries/loans-for-farmers.vue' /* webpackChunkName: "pages/industries/loans-for-farmers" */))
const _63a35d9a = () => interopDefault(import('../../../pages/industries/loans-for-landscapers.vue' /* webpackChunkName: "pages/industries/loans-for-landscapers" */))
const _29375a66 = () => interopDefault(import('../../../pages/industries/loans-for-restaurants.vue' /* webpackChunkName: "pages/industries/loans-for-restaurants" */))
const _5c31e24d = () => interopDefault(import('../../../pages/industries/manufacturing-financing.vue' /* webpackChunkName: "pages/industries/manufacturing-financing" */))
const _aa8ee708 = () => interopDefault(import('../../../pages/industries/transportation-business-loans.vue' /* webpackChunkName: "pages/industries/transportation-business-loans" */))
const _b780d7ca = () => interopDefault(import('../../../pages/industries/working-capital-financing.vue' /* webpackChunkName: "pages/industries/working-capital-financing" */))
const _2a9d1a6a = () => interopDefault(import('../../../pages/index.vue' /* webpackChunkName: "pages/index" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/2nd-mortgage",
    component: _0409b50e,
    name: "2nd-mortgage"
  }, {
    path: "/2nd-mortgage-landing-page",
    component: _4735f189,
    name: "2nd-mortgage-landing-page"
  }, {
    path: "/about-us",
    component: _95ca2f14,
    name: "about-us"
  }, {
    path: "/accessibility-policy",
    component: _e5fe36ae,
    name: "accessibility-policy"
  }, {
    path: "/asset-based-lending",
    component: _1f7af618,
    name: "asset-based-lending"
  }, {
    path: "/blog",
    component: _67d1493a,
    name: "blog"
  }, {
    path: "/brokers",
    component: _0b85c152,
    name: "brokers"
  }, {
    path: "/careers",
    component: _95df9e66,
    name: "careers"
  }, {
    path: "/communication-policy",
    component: _f3e61dbe,
    name: "communication-policy"
  }, {
    path: "/contact-us",
    component: _4658a6fa,
    name: "contact-us"
  }, {
    path: "/equipment-financing-landing-page-1",
    component: _21668256,
    name: "equipment-financing-landing-page-1"
  }, {
    path: "/equipment-loan",
    component: _30d284e7,
    name: "equipment-loan"
  }, {
    path: "/faq",
    component: _04028aa4,
    name: "faq"
  }, {
    path: "/fb-equipment-financing-landing-page",
    component: _5ff9c3a3,
    name: "fb-equipment-financing-landing-page"
  }, {
    path: "/industries",
    component: _46ca7717,
    name: "industries"
  }, {
    path: "/invest",
    component: _720cd80d,
    name: "invest"
  }, {
    path: "/invoice-factoring",
    component: _15393aaa,
    name: "invoice-factoring"
  }, {
    path: "/john",
    component: _39fe1a23,
    name: "john"
  }, {
    path: "/jun",
    component: _18e364ca,
    name: "jun"
  }, {
    path: "/ken",
    component: _0d26feec,
    name: "ken"
  }, {
    path: "/lei",
    component: _41c6c4a8,
    name: "lei"
  }, {
    path: "/loan-calculator",
    component: _0fa12f17,
    name: "loan-calculator"
  }, {
    path: "/nonprofit-financing",
    component: _3de84fb3,
    name: "nonprofit-financing"
  }, {
    path: "/not-found",
    component: _495e12a0,
    name: "not-found"
  }, {
    path: "/partners",
    component: _0ba3ac7a,
    name: "partners"
  }, {
    path: "/privacy-notice-for-california-residents",
    component: _0e12df7a,
    name: "privacy-notice-for-california-residents"
  }, {
    path: "/privacy-policy",
    component: _5edfba2f,
    name: "privacy-policy"
  }, {
    path: "/roi-calculator",
    component: _2d5376bb,
    name: "roi-calculator"
  }, {
    path: "/sba-loans",
    component: _4d403b00,
    name: "sba-loans"
  }, {
    path: "/team",
    component: _2bcb8675,
    name: "team"
  }, {
    path: "/terms-of-use",
    component: _77ce46af,
    name: "terms-of-use"
  }, {
    path: "/thank-you",
    component: _d071d158,
    name: "thank-you"
  }, {
    path: "/vendor-financing",
    component: _a546252c,
    name: "vendor-financing"
  }, {
    path: "/why-american-credit",
    component: _16fba94e,
    name: "why-american-credit"
  }, {
    path: "/working-capital-landing-page",
    component: _72d3d97e,
    name: "working-capital-landing-page"
  }, {
    path: "/industries/commercial-construction-loans",
    component: _c75317a2,
    name: "industries-commercial-construction-loans"
  }, {
    path: "/industries/commercial-real-estate-loans",
    component: _08d7a7ce,
    name: "industries-commercial-real-estate-loans"
  }, {
    path: "/industries/commercial-truck-financing",
    component: _40f8f2b1,
    name: "industries-commercial-truck-financing"
  }, {
    path: "/industries/commercial-vehicle-loans",
    component: _1780f8ac,
    name: "industries-commercial-vehicle-loans"
  }, {
    path: "/industries/excavator-financing",
    component: _126035ea,
    name: "industries-excavator-financing"
  }, {
    path: "/industries/loans-for-contractors",
    component: _537182d6,
    name: "industries-loans-for-contractors"
  }, {
    path: "/industries/loans-for-farmers",
    component: _304e9de7,
    name: "industries-loans-for-farmers"
  }, {
    path: "/industries/loans-for-landscapers",
    component: _63a35d9a,
    name: "industries-loans-for-landscapers"
  }, {
    path: "/industries/loans-for-restaurants",
    component: _29375a66,
    name: "industries-loans-for-restaurants"
  }, {
    path: "/industries/manufacturing-financing",
    component: _5c31e24d,
    name: "industries-manufacturing-financing"
  }, {
    path: "/industries/transportation-business-loans",
    component: _aa8ee708,
    name: "industries-transportation-business-loans"
  }, {
    path: "/industries/working-capital-financing",
    component: _b780d7ca,
    name: "industries-working-capital-financing"
  }, {
    path: "/",
    component: _2a9d1a6a,
    name: "index"
  }, {
    path: "*",
    component: _495e12a0,
    name: "custom"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
